"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFlag = void 0;
exports.default = Flag;
var _react = _interopRequireDefault(require("react"));
var flags = _interopRequireWildcard(require("./flags"));
var _styles = require("../styles");
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function Flag(props) {
  const {
    $iso,
    iso: oldIsoProp,
    width = '16px',
    ...restProps
  } = props;
  const iso = oldIsoProp || $iso;
  // @ts-ignore
  const FlagComponent = flags[`Flag${iso.toUpperCase()}`];
  //$FlowExpectedError[cannot-spread-inexact]
  return /*#__PURE__*/_react.default.createElement(FlagComponent, _extends({
    width: width,
    "data-iso": iso
  }, restProps));
}
const StyledFlag = exports.StyledFlag = (0, _styles.styled)(Flag, ({
  $size = _constants.SIZE.default,
  $theme: {
    sizing
  }
}) => {
  const sizeToWidth = {
    [_constants.SIZE.mini]: sizing.scale700,
    [_constants.SIZE.compact]: sizing.scale800,
    [_constants.SIZE.default]: sizing.scale900,
    [_constants.SIZE.large]: sizing.scale1000
  };
  return {
    width: sizeToWidth[$size]
  };
});
StyledFlag.displayName = "StyledFlag";